import { useState, useMemo } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// helper: normalize arabic text
const normalizeArabic = (text) => {
  return text
    .replace(/[أإآا]/g, "ا")
    .replace(/ى/g, "ي")
    .replace(/ؤ/g, "و")
    .replace(/ئ/g, "ي")
    .replace(/ة/g, "ه")
    .replace(/[ًٌٍَُِّْ]/g, ""); // remove tashkeel
};

const HeaderSearch = ({ navigationItems }) => {
  const [query, setQuery] = useState("");
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  // Flatten all items + subItems
  const allItems = useMemo(() => {
    let items = [];
    navigationItems.forEach((item) => {
      if (item.subItems) {
        items.push(...item.subItems);
      } else {
        items.push(item);
      }
    });
    return items;
  }, [navigationItems]);

  // Fuzzy filter
  const filtered = allItems.filter((item) => {
    const normText = normalizeArabic(item.text).toLowerCase();
    const normQuery = normalizeArabic(query).toLowerCase();

    // create loose regex (letters in order but not necessarily contiguous)
    const regex = new RegExp(normQuery.split("").join(".*"), "i");
    return regex.test(normText);
  });

  return (
    <div className="relative w-96 z-50">
      <div className="flex items-center">
        <FaSearch className="me-4 text-white" />
        <input
          type="text"
          className="bg-transparent outline-none text-sm w-full h-6 text-white"
          placeholder={currentLang === "en" ? "search for a page.." : "ابحث عن صفحة..."}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setTimeout(() => setFocused(false), 200)}
        />
      </div>
      {focused && query && (
        <div className="absolute mt-2 max-h-80 w-full overflow-y-auto rounded-b-lg  bg-red-700 shadow-lg scrollable">
          {filtered.length > 0 ? (
            filtered.map((item, idx) => (
              <div
                key={idx}
                className="flex cursor-pointer items-center gap-2 px-3 py-2 text-sm text-white bg-furthly hover:bg-secondary"
                onClick={() => {
                  navigate(item.to);
                  setQuery("");
                }}
              >
                {item.icon}
                <span className="text-white">{item.text}</span>
              </div>
            ))
          ) : (
            <div className="px-3 py-2 text-sm text-gray-500">لا يوجد نتائج</div>
          )}
        </div>
      )}
    </div>
  );
};

export default HeaderSearch;
